import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { APP_STORE_URL, PLAY_STORE_URL } from '~/lib/appStores';

const WEBSITE_URL = 'https://nsave.com';
const GOOGLE_ADS_ID = 'AW-16515329321';
const META_PIXEL_ID = '746259351667760';

function redirectUrlForUserAgent(userAgent: string): string {
  if (/Mac|iPad|iPhone|iPod/i.test(userAgent)) return APP_STORE_URL;
  if (/Android/i.test(userAgent)) return PLAY_STORE_URL;
  return WEBSITE_URL;
}

export const Route = createFileRoute('/app-store-redirect')({
  head: () => ({
    meta: [{ title: 'Download the nsave app' }, { name: 'robots', content: 'noindex' }],
    scripts: [
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`,
        async: true,
      },
      {
        children: `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());gtag('config','${GOOGLE_ADS_ID}');`,
      },
      {
        children: `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${META_PIXEL_ID}');fbq('track','PageView');`,
      },
    ],
  }),
  component: AppStoreRedirectPage,
});

function AppStoreRedirectPage() {
  useEffect(() => {
    const redirectUrl = redirectUrlForUserAgent(window.navigator.userAgent);
    // Give the campaign tracking tags a moment to initialize before leaving.
    const timeoutId = window.setTimeout(() => window.location.assign(redirectUrl), 100);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <div className="mx-auto h-8 w-8 animate-spin rounded-full border-b-2 border-[#D60707]" />
        <p className="mt-4 text-grey-600">Redirecting to app store...</p>
      </div>
      <noscript>
        <img
          height="1"
          width="1"
          className="hidden"
          src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </main>
  );
}
